<div class="audit-modal-overlay" [class.active]="isVisible" (click)="closeModal()">
  <div class="audit-modal-panel" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="audit-modal-header">
      <h3 class="audit-modal-title">Audit Trail</h3>
      <div class="audit-header-right">
        <div class="audit-date-range-wrapper">
          <input type="date" class="date-input date-input-from" (change)="onFromDateChange($event)" placeholder="MM/DD/YYYY" />
          <span class="date-range-sep">–</span>
          <input type="date" class="date-input date-input-to" (change)="onToDateChange($event)" placeholder="MM/DD/YYYY" />
          <span class="material-icons date-cal-icon">calendar_today</span>
        </div>
        <button class="audit-close-btn" (click)="closeModal()">
          <span class="material-icons">close</span>
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div class="audit-loading" *ngIf="isLoading">
      <span class="material-icons spin">autorenew</span> Loading...
    </div>

    <!-- No data -->
    <div class="audit-no-data" *ngIf="!isLoading && records.length === 0">
      No audit records found.
    </div>

    <!-- Accordion list -->
    <div class="audit-list" *ngIf="!isLoading && records.length > 0">
      <div class="audit-row" *ngFor="let record of records">

        <!-- Row header (always visible) -->
        <div class="audit-row-header" (click)="toggleRow(record.Id)">
          <div class="audit-row-meta">
            <div class="audit-meta-item">
              <span class="meta-label">Updated By</span>
              <span class="meta-value">{{ record.UpdatedBy }}</span>
            </div>
            <span class="audit-meta-sep">|</span>
            <div class="audit-meta-item">
              <span class="meta-label">Updated At</span>
              <span class="meta-value">{{ record.UpdatedAt | date:'MM-dd-yyyy | hh:mm a' }}</span>
            </div>
            <span class="audit-meta-sep">|</span>
            <div class="audit-meta-item">
              <span class="meta-label">Agent Name</span>
              <span class="meta-value">{{ record.AgentName || '–' }}</span>
            </div>
          </div>
          <div class="audit-row-right">
            <span class="action-badge"
              [ngStyle]="{
                'color': getActionStyle(record.Action).color,
                'background': getActionStyle(record.Action).background,
                'border': '1px solid ' + getActionStyle(record.Action).border
              }">
              {{ record.Action | titlecase }}
            </span>
            <span class="material-icons chevron" [class.open]="isExpanded(record.Id)">
              expand_more
            </span>
          </div>
        </div>

        <!-- Expanded body — one section per JSON key, Past + Recent side by side under each -->
        <div class="audit-row-body" *ngIf="isExpanded(record.Id)">
          <ng-container *ngFor="let key of getMergedKeys(record.PreviousState, record.CurrentState)">
            <div class="activity-section">
              <div class="activity-section-title">{{ formatKey(key) }}</div>
              <div class="activity-row">

                <!-- Past Activity -->
                <div class="activity-col">
                  <div class="activity-col-label">Past Activity</div>
                  <ng-container *ngIf="record.PreviousState && getSectionValue(record.PreviousState, key) !== undefined; else pastEmpty">
                    <ng-container [ngSwitch]="true">
                      <ng-container *ngSwitchCase="isObjectValue(getSectionValue(record.PreviousState, key))">
                        <div class="activity-kv" *ngFor="let entry of getObjectEntries(getSectionValue(record.PreviousState, key))">
                          <span class="kv-key">{{ formatKey(entry.k) }}</span>
                          <span class="kv-val">{{ formatValue(entry.v) }}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="isArrayValue(getSectionValue(record.PreviousState, key))">
                        <div class="activity-array-item" *ngFor="let item of getSectionValue(record.PreviousState, key)">
                          {{ formatValue(item) }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="activity-value">{{ formatValue(getSectionValue(record.PreviousState, key)) }}</div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #pastEmpty><div class="activity-empty">—</div></ng-template>
                </div>

                <!-- Recent Activity -->
                <div class="activity-col">
                  <div class="activity-col-label">Recent Activity</div>
                  <ng-container *ngIf="record.CurrentState && getSectionValue(record.CurrentState, key) !== undefined; else recentEmpty">
                    <ng-container [ngSwitch]="true">
                      <ng-container *ngSwitchCase="isObjectValue(getSectionValue(record.CurrentState, key))">
                        <div class="activity-kv" *ngFor="let entry of getObjectEntries(getSectionValue(record.CurrentState, key))">
                          <span class="kv-key">{{ formatKey(entry.k) }}</span>
                          <span class="kv-val">{{ formatValue(entry.v) }}</span>
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchCase="isArrayValue(getSectionValue(record.CurrentState, key))">
                        <div class="activity-array-item" *ngFor="let item of getSectionValue(record.CurrentState, key)">
                          {{ formatValue(item) }}
                        </div>
                      </ng-container>
                      <ng-container *ngSwitchDefault>
                        <div class="activity-value">{{ formatValue(getSectionValue(record.CurrentState, key)) }}</div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #recentEmpty><div class="activity-empty">—</div></ng-template>
                </div>

              </div>
            </div>
          </ng-container>

          <!-- If both states are null -->
          <div class="activity-empty" *ngIf="!record.PreviousState && !record.CurrentState">No details available.</div>
        </div>

      </div>
    </div>

    <!-- Pagination -->
    <div class="audit-pagination" *ngIf="!isLoading && totalCount > 0">
      <div class="pagination-info">
        Showing {{ showingFrom }}–{{ showingTo }} of {{ totalCount }}
      </div>
      <div class="pagination-controls">
        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(1)" title="First">«</button>
        <button class="page-btn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)" title="Previous">‹</button>
        <button
          class="page-btn"
          *ngFor="let p of getPageNumbers()"
          [class.active]="p === currentPage"
          (click)="goToPage(p)">
          {{ p }}
        </button>
        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)" title="Next">›</button>
        <button class="page-btn" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)" title="Last">»</button>
      </div>
    </div>

  </div>
</div>
